import { Button, ButtonProps } from '@mui/material'
import { FC } from 'react'

interface ButtonFieldProps extends ButtonProps {
  children?: React.ReactNode
  startIcon?: any
  endIcon?: any
  style?: {
    height: string
    borderRadius: string
    minWidth?: string
    margin?: string
    backgroundColor?: string
    opacity?: number
    border?: string
    fontFamily?: string
    fontSize?: string
    fontStyle?: string
    fontWeight?: number
    lineHeight?: string
    letterSpacing?: string
    background?: string
    color?: string
  }
  name: string
  onClick?: (e?: any) => void
}

const ButtonField: FC<ButtonFieldProps> = ({
  startIcon,
  style,
  name,
  onClick,
  endIcon,
  sx,
  ...rest
}) => {
  return (
    <Button
      id="basic-button"
      aria-haspopup="true"
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      // `style` and `sx` are composed rather than one replacing the other.
      // `sx` used to arrive with the rest of the props and land on top of the
      // whole `sx={{ ...style }}`, so a caller that passed both lost every
      // dimension `style` set — height, radius, min width — and the button
      // shrank to fit its label. Later entries still win per property, so a
      // caller that overrode one value in `sx` keeps doing so.
      sx={[style ?? {}, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      {name}
    </Button>
  )
}

export default ButtonField
